import React, { useState } from "react";
//import s from "./style.module.css";
import Vizualisation from "../../../../components/Vizualisation";
import useVizualisation from "../../../../helpers/useVizualisation";
import correlations from "../../data/correlations.json";
import { scalePoint, scaleLinear } from "d3-scale";
import { Text } from "@visx/text";

const showMap = {
  open: ["Open"],
  conditional: ["Open", "Conditional"],
  limited: ["Open", "Conditional", "Limited"],
};

const ArrowChart = ({
  data,
  title,
  note,
  source,
  showArrow,
  associated,
  more,
  less,
  open,
  conditional,
  transfers,
  limited,
}) => {
  const { ref, width, height, windowSize, inView } = useVizualisation();

  const margin = {
    top: 10,
    right: 40,
    bottom: 0,
    left: width < 700 ? 30 : 90,
  };
  const chartWidth = width - margin.left - margin.right;
  const chartHeight = 500 - margin.top - margin.bottom;

  const models = [...new Set(correlations.map((d) => d.Label))];
  const modelsCodes = [...new Set(correlations.map((d) => d.Model))];

  const pointScale = scalePoint()
    .domain(models)
    .range([0, chartWidth])
    .padding(0.5);

  const linearScale = scaleLinear().domain([-1.5, 1.5]).range([chartHeight, 0]);

  const colorScale = {
    Open: "#31989E",
    Conditional: "#F2C118",
    Limited: "#481F7C",
  };

  const labels = [
    {
      text: open,
      verticalAnchor: "start",
      textAnchor: "middle",
      model: "Open",
      x: pointScale("Open transfers"),
      dy: 4,
      dx: 0,
    },
    {
      text: conditional,
      verticalAnchor: "start",
      textAnchor: "end",
      model: "Conditional",
      x: pointScale("Conditional transfers"),
      dy: width < 600 ? 18 : 4,
      dx: -10,
    },
    {
      text: transfers,
      verticalAnchor: "end",
      textAnchor: "start",
      model: "Conditional",
      x: pointScale("Conditional transfers"),
      dy: width < 600 ? -18 : -4,
      dx: 10,
    },
    {
      text: limited,
      verticalAnchor: "end",
      textAnchor: "middle",
      model: "Limited",
      x: pointScale("Limited transfers"),
      dy: -4,
      dx: 0,
    },
  ];

  return (
    <Vizualisation
      title={title}
      note={note}
      source={source}
      ref={ref}
      size="large"
    >
      <svg width={width} height={500}>
        <defs>
          <marker
            id="arrow"
            viewBox="0 -10 20 20"
            refX={5}
            refY={0}
            markerWidth={8}
            markerHeight={8}
            orient="auto"
          >
            <path d="M0,-10L20,0L0,10" className="arrowhead"></path>
          </marker>
          {modelsCodes.map((d) => {
            return (
              <marker
                id={"arrow-" + d}
                viewBox="0 -10 20 20"
                refX={0}
                refY={0}
                markerWidth={3}
                markerHeight={3}
                orient="auto"
              >
                <path
                  d="M0,-10L20,0L0,10"
                  className="arrowhead"
                  fill={colorScale[d]}
                ></path>
              </marker>
            );
          })}
        </defs>
        <g
          className="chart"
          transform={`translate(${margin.left}, ${margin.top})`}
        >
          {correlations.map((d) => {
            return (
              <>
                <line
                  x1={pointScale(d.Label)}
                  x2={pointScale(d.Label)}
                  y1={linearScale(0)}
                  y2={
                    d.Correlation < 0
                      ? linearScale(d.Correlation) - 20
                      : linearScale(d.Correlation) + 20
                  }
                  stroke={colorScale[d.Model]}
                  strokeWidth={12}
                  markerEnd={`url(#arrow-${d.Model})`}
                  opacity={showMap[showArrow].includes(d.Model) ? 1 : 0}
                ></line>
              </>
            );
          })}
          <line
            x1={0}
            x2={chartWidth}
            y1={linearScale(0)}
            y2={linearScale(0)}
            stroke={"#cccccc"}
            strokeWidth={1}
          ></line>
          <g transform={`translate(${width < 700 ? -margin.left + 10 : 0}, 0)`}>
            <Text
              x={width < 700 ? margin.left + 40 : -2}
              y={width < 700 ? linearScale(0) - 50 : linearScale(0)}
              fontSize={"11px"}
              width={120}
              verticalAnchor={width < 700 ? "start" : "middle"}
              textAnchor={"end"}
            >
              {associated}
            </Text>
            <line
              x1={0}
              x2={0}
              y1={linearScale(0)}
              y2={linearScale(0) - 32}
              stroke={"#000000"}
              strokeWidth={1}
              markerEnd={"url(#arrow)"}
            ></line>
            <line
              x1={0}
              x2={0}
              y1={linearScale(0)}
              y2={linearScale(0) + 32}
              stroke={"#000000"}
              strokeWidth={1}
              markerEnd={"url(#arrow)"}
            ></line>

            <Text
              x={6}
              y={linearScale(0) - 32}
              fontSize={"11px"}
              width={80}
              verticalAnchor={"end"}
            >
              {more}
            </Text>
            <Text
              x={6}
              y={linearScale(0) + 32}
              fontSize={"11px"}
              width={80}
              verticalAnchor={"start"}
            >
              {less}
            </Text>
          </g>
          {labels.map((d) => {
            return (
              <Text
                key={"label-" + d.text}
                x={d.x + d.dx}
                y={linearScale(0)}
                fill={colorScale[d.model]}
                textAnchor={d.textAnchor}
                verticalAnchor={d.verticalAnchor}
                dy={d.dy}
                opacity={showMap[showArrow].includes(d.model) ? 1 : 0}
              >
                {d.text}
              </Text>
            );
          })}
        </g>
      </svg>
    </Vizualisation>
  );
};

export default ArrowChart;
